module.exports = __webpack_public_path__ + "img/icon-pending.0ffd4758.svg";